import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface CriticalPathLengthChartProps {
  xAxisData: string[];
  criticalPathDays: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function CriticalPathLengthChart({
  xAxisData,
  criticalPathDays,
  height = 260,
  showDataLabels = true,
  density = 'overview',
}: CriticalPathLengthChartProps) {
  const series = useMemo(
    () => [{ name: 'Critical path (days)', data: criticalPathDays }],
    [criticalPathDays]
  );
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
